import { render, staticRenderFns } from "./Chatbots.vue?vue&type=template&id=667387ad&scoped=true"
import script from "./Chatbots.vue?vue&type=script&lang=js"
export * from "./Chatbots.vue?vue&type=script&lang=js"
import style0 from "./Chatbots.vue?vue&type=style&index=0&id=667387ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667387ad",
  null
  
)

export default component.exports